import CCCHtmlPanel from "../components/html-panel";
import { CCCPanel } from "../components/panel/panel";
import { selectAnchor } from "../core/utilities";
import OContentModel from "../models/OContentModel";

export default class YouTubeVideoPanelController {
  panelComponent: CCCPanel = null;
  youtubeComponent: CCCHtmlPanel = null;
  youtubeModel: OContentModel = null;
  private htmlContent = '<div class="ccc-loading"></div>';

  async init(anchor: string, catName: string): Promise<void> {
    this.panelComponent = <CCCPanel>selectAnchor(anchor);
    if (this.panelComponent) {
      try {
        this.youtubeComponent = <CCCHtmlPanel>(
          selectAnchor("ccc-html-panel", this.panelComponent)
        );
        this.youtubeComponent.loading = true;
        this.htmlContent = await OContentModel.getYoutubePanel(catName);
        if (this.htmlContent !== "") {
          this._updateComponentState();
        } else {
          this.panelComponent.hide();
        }
        this.youtubeComponent.loading = false;
      } catch (e) {
        console.error(e);
        this.panelComponent.hide();
      }
    }
  }

  setLoading(visible: boolean): void {
    this.youtubeComponent.loading = visible;
  }

  protected _updateComponentState(): void {
    this.youtubeComponent.setState({
      html: this.htmlContent,
    });
  }
}
